class MediaMarquee {
  constructor(section) {
    this.section = section;
    this.wrapper = section.querySelector('.section-media-marquee__wrapper');
    this.track = section.querySelector('.section-media-marquee__track');
    this.content = section.querySelector('.section-media-marquee__content');

    if (!this.track || !this.content) return;

    this.init();
  }

  init() {
    this.duplicateContent();
    this.setSpeed();
  }

  duplicateContent() {
    // Clone the content multiple times to create seamless infinite scroll and avoid empty space
    for (let i = 0; i < 3; i++) {
      const clone = this.content.cloneNode(true);
      this.track.appendChild(clone);
    }
  }

  setSpeed() {
    // Get speed from data attribute (in seconds)
    const speed = this.track.dataset.speed || 40;

    // Calculate the width of one content set
    const contentWidth = this.content.offsetWidth;

    // Apply animation duration to the track
    this.track.style.setProperty('--marquee-duration', `${speed}s`);
    this.track.style.setProperty('--marquee-distance', `-${contentWidth}px`);
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="w-media-marquee"]');
  sections.forEach(section => new MediaMarquee(section));
});

// Shopify theme editor support
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-media-marquee"]');
    if (section) {
      new MediaMarquee(section);
    }
  });
}
